import { Component } from '@angular/core';

interface DropdownItem {
  id: string | number;
  name: string;
  category?: string;
}

interface CustomItem {
  id: number;
  label: string;
  description?: string;
}

interface NumericItem {
  id: number;
  name: string;
  value: number;
}

@Component({
  selector: 'app-dropdown-showcase',
  templateUrl: './dropdown-showcase.component.html',
  styleUrls: ['./dropdown-showcase.component.scss']
})
export class DropdownShowcaseComponent {
  // Basic items
  basicItems: DropdownItem[] = [
    { id: 1, name: 'Option 1' },
    { id: 2, name: 'Option 2' },
    { id: 3, name: 'Option 3' },
    { id: 4, name: 'Option 4' }
  ];

  // Fruit items
  fruitItems: DropdownItem[] = [
    { id: 'apple', name: 'Apple' },
    { id: 'banana', name: 'Banana' },
    { id: 'orange', name: 'Orange' },
    { id: 'mango', name: 'Mango' },
    { id: 'grape', name: 'Grape' }
  ];

  // Country items
  countryItems: DropdownItem[] = [
    { id: 'us', name: 'United States' },
    { id: 'uk', name: 'United Kingdom' },
    { id: 'ca', name: 'Canada' },
    { id: 'au', name: 'Australia' },
    { id: 'in', name: 'India' }
  ];

  // Status items
  statusItems: DropdownItem[] = [
    { id: 'active', name: 'Active' },
    { id: 'inactive', name: 'Inactive' },
    { id: 'pending', name: 'Pending' },
    { id: 'archived', name: 'Archived' }
  ];

  // Custom field items
  customFieldItems: CustomItem[] = [
    { id: 1, label: 'Item One', description: 'First option' },
    { id: 2, label: 'Item Two', description: 'Second option' },
    { id: 3, label: 'Item Three', description: 'Third option' }
  ];

  // Long name items
  longNameItems: DropdownItem[] = [
    { id: 1, name: 'Very Long Option Name That Might Overflow' },
    { id: 2, name: 'Another Extremely Long Option Description' },
    { id: 3, name: 'This is a test with a very descriptive name' }
  ];

  // Numeric items
  numericItems: NumericItem[] = [
    { id: 1, name: 'One', value: 1 },
    { id: 2, name: 'Two', value: 2 },
    { id: 3, name: 'Three', value: 3 },
    { id: 4, name: 'Four', value: 4 },
    { id: 5, name: 'Five', value: 5 }
  ];

  // Selected values - Single Select
  selectedBasic: DropdownItem | null = null;
  selectedFruit: DropdownItem | null = null;
  selectedCountry: DropdownItem | null = null;
  selectedStatus: DropdownItem | null = null;
  selectedMulti: DropdownItem | null = null;
  preSelectedItem: DropdownItem | null = this.statusItems[0];

  // Selected values - Multi Select
  selectedFruits: DropdownItem[] = [];
  selectedCountries: DropdownItem[] = [];
  selectedStatuses: DropdownItem[] = [];

  // Empty list
  emptyItems: DropdownItem[] = [];

  // Many items
  manyItems: DropdownItem[] = Array.from({ length: 20 }, (_, i) => ({
    id: i + 1,
    name: `Item ${i + 1}`
  }));

  // Large country list — good for search demo
  largeCountryItems: DropdownItem[] = [
    { id: 'us', name: 'United States' },
    { id: 'uk', name: 'United Kingdom' },
    { id: 'ca', name: 'Canada' },
    { id: 'au', name: 'Australia' },
    { id: 'in', name: 'India' },
    { id: 'de', name: 'Germany' },
    { id: 'fr', name: 'France' },
    { id: 'jp', name: 'Japan' },
    { id: 'cn', name: 'China' },
    { id: 'br', name: 'Brazil' },
    { id: 'mx', name: 'Mexico' },
    { id: 'es', name: 'Spain' },
    { id: 'it', name: 'Italy' },
    { id: 'kr', name: 'South Korea' },
    { id: 'sg', name: 'Singapore' },
    { id: 'nz', name: 'New Zealand' },
    { id: 'za', name: 'South Africa' },
    { id: 'ng', name: 'Nigeria' },
    { id: 'eg', name: 'Egypt' },
    { id: 'ar', name: 'Argentina' }
  ];

  selectedSearchableItem: DropdownItem | null = null;
  selectedSearchableItems: DropdownItem[] = [];

  onSelectionChange(item: any, name: string): void {
    console.log(`${name} selected:`, item);
  }

  onMultiSelectionChange(items: any[], name: string): void {
    console.log(`${name} selected:`, items);
  }
}
